import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { fetchTeams, requestToJoinTeam } from "../api/team_stuff";

const columns = [
    {
        name: "Team",
        cell: (row) => (
            <Link to={`/team/${encodeURIComponent(row.team)}`} className="text-blue-500 hover:underline">
                {row.team}
            </Link>
        ),
        sortable: true,
        center: "true",
    },
    { name: "Organisation", selector: (row) => row.organisation, sortable: true, center: "true" },
    { name: "Status", selector: (row) => row.status, sortable: true, center: "true" },
    {
        name: "Actions",
        cell: (row) => (
            <div className="text-center">
                <button
                    onClick={async () => await requestToJoinTeam(row.team)}
                    className={`px-3 py-2 text-sm font-medium rounded-md ${
                        row.status === "Open" ? "bg-blue-500 text-white hover:bg-blue-700" : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                    disabled={row.status !== "Open"}
                >
                    Join
                </button>
            </div>
        ),
        ignoreRowClick: true,
        allowoverflow: true,
        center: "true",
    },
];

const ViewTeamsTable = () => {
    const navigate = useNavigate();
    const [teams, setTeams] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTeams()
            .then((data) => {
                setTeams(data || []);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching teams:", error);
                setLoading(false);
            });
    }, []);

    const filteredData = teams.filter(
        (item) =>
            (item.team && item.team.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.organisation && item.organisation.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.status && item.status.toLowerCase().includes(filterText.toLowerCase()))
    );

    return (
        <div>
            <div className="p-4">
                <div className="flex justify-end mb-4">
                    <input
                        type="text"
                        placeholder="Search..."
                        onChange={(e) => setFilterText(e.target.value)}
                        className="w-full sm:w-64 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
                <div className="rounded-lg border border-gray-200 shadow-md overflow-hidden">
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        pagination
                        progressPending={loading}
                        progressComponent={<div className="p-4 text-center">Loading...</div>}
                        noDataComponent={<div className="p-4 text-center">No records to display</div>}
                        customStyles={{
                            table: {
                                style: {
                                    textAlign: "center",
                                    borderWidth: "1px",
                                    borderStyle: "solid",
                                    borderColor: "#e5e7eb",
                                },
                            },
                            headRow: {
                                style: {
                                    backgroundColor: "#f3f4f6",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    borderBottom: "2px solid #e5e7eb",
                                },
                            },
                            headCells: {
                                style: {
                                    padding: "12px",
                                    textAlign: "center",
                                    borderRight: "1px solid #e5e7eb",
                                },
                            },
                            rows: {
                                style: {
                                    textAlign: "center",
                                    borderBottom: "1px solid #e5e7eb",
                                    "&:nth-of-type(even)": {
                                        backgroundColor: "#f9fafb",
                                    },
                                    "&:nth-of-type(odd)": {
                                        backgroundColor: "#ffffff",
                                    },
                                },
                            },
                            cells: {
                                style: {
                                    padding: "10px",
                                    borderRight: "1px solid #e5e7eb",
                                    textAlign: "center",
                                },
                            },
                        }}
                    />
                </div>
            </div>
            <div className="text-center">
                <button
                    onClick={() => navigate("/create_team")}
                    className="px-3 py-2 text-sm font-medium rounded-md bg-blue-500 text-white hover:bg-blue-700"
                >
                    Create Team
                </button>
            </div>
        </div>
    );
};

export default ViewTeamsTable;
